/* eslint-disable react/prop-types */
import React from 'react';
import { createContext, useState, useEffect } from 'react';

export const LogContext = createContext();

export function LogProvider({ children }) {
  const storedLogs = localStorage.getItem('logs');
  const initialLogs = storedLogs ? JSON.parse(storedLogs) : [];

  const [logData, setLogData] = useState(initialLogs);

  const [loadIndex, setLoadIndex] = useState(initialLogs);

  useEffect(() => {
    localStorage.setItem('logs', JSON.stringify(logData));
  }, [logData]);

  return (
    <LogContext.Provider
      value={{ logData, setLogData, loadIndex, setLoadIndex }}
    >
      {children}
    </LogContext.Provider>
  );
}
